module.exports = __webpack_public_path__ + "75b4505da03b297010815a94c0ccd370.svg";